import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ClientsFilterType } from '../../../utils/type';

export type ExtendedClientsFilterType = ClientsFilterType & {
  pageNo?: number;
};

const initialClinetListFilterState: ExtendedClientsFilterType = {
  birthStartDate: null,
  birthEndDate: null,
  startDate: null,
  endDate: null,
  startAge: '',
  endAge: '',
  ifspDueStartDate: null,
  ifspDueEndDate: null,
  serviceCoordinator: '',
  assesmentStartHour: '',
  assesmentEndHour: '',
  status: '',
  ageMonthStart: '',
  ageMonthEnd: '',
  intakeFacilitator: '',
  noIntakeFacilitator: '',
  noServiceCoordinator: '',
  pageNo: 0,
};

const clinetListFilterSlice = createSlice({
  name: 'clientListFilter',
  initialState: initialClinetListFilterState,
  reducers: {
    setClientListFilters: (
      state,
      action: PayloadAction<Partial<ExtendedClientsFilterType>>,
    ) => {
      state.birthStartDate = action.payload.birthStartDate
        ? action.payload.birthStartDate
        : null;
      state.birthEndDate = action.payload.birthEndDate
        ? action.payload.birthEndDate
        : null;
      state.startDate = action.payload.startDate
        ? action.payload.startDate
        : null;
      state.endDate = action.payload.endDate ? action.payload.endDate : null;
      state.ageMonthStart = action.payload.ageMonthStart
        ? action.payload.ageMonthStart
        : '';
      state.ageMonthEnd = action.payload.ageMonthEnd
        ? action.payload.ageMonthEnd
        : '';
      state.startAge = action.payload.startAge ? action.payload.startAge : '';
      state.endAge = action.payload.endAge ? action.payload.endAge : '';
      state.ifspDueStartDate = action.payload.ifspDueStartDate
        ? action.payload.ifspDueStartDate
        : null;
      state.ifspDueEndDate = action.payload.ifspDueEndDate
        ? action.payload.ifspDueEndDate
        : null;
      state.assesmentStartHour = action.payload.assesmentStartHour
        ? action.payload.assesmentStartHour
        : '';
      state.assesmentEndHour = action.payload.assesmentEndHour
        ? action.payload.assesmentEndHour
        : '';
      state.status = action.payload.status ? action.payload.status : '';
      state.serviceCoordinator = action.payload.serviceCoordinator
        ? action.payload.serviceCoordinator
        : '';
      state.intakeFacilitator = action.payload.intakeFacilitator
        ? action.payload.intakeFacilitator
        : '';
      state.noIntakeFacilitator = action.payload.noIntakeFacilitator
        ? action.payload.noIntakeFacilitator
        : '';
      state.noServiceCoordinator = action.payload.noServiceCoordinator
        ? action.payload.noServiceCoordinator
        : '';
      state.pageNo = action.payload.pageNo ? action.payload.pageNo : 0;
    },
    resetClientListFilters: () => initialClinetListFilterState,
  },
  extraReducers: (builder) => {
    builder.addCase(
      'RESET_REDUX_APP_STATES',
      () => initialClinetListFilterState,
    );
  },
});

export const { setClientListFilters, resetClientListFilters } =
  clinetListFilterSlice.actions;
export default clinetListFilterSlice.reducer;
